// Rails 8 / jsbundling-rails entry point — replaces app/javascript/packs/agency.js
// Built by `yarn build` via esbuild → app/assets/builds/agency.js, served by Propshaft.

import "@rails/ujs"
import "@rails/activestorage"
import "./channels"
import "jquery-ui-dist/jquery-ui.js"

import $ from "jquery"
window.$ = $
window.jQuery = $

import "./packs/lib/jquery.min.js"
import "./packs/lib/bootstrap.min.js"
import "./select2-init.js"
import "./packs/agency/qr-code.js"
import "./packs/agency/data-orders.js"
import "./packs/agency/orders.js"
import "./packs/agency/store_order_set_products.js"
import "./packs/paginate.js"
import "./packs/agency/deadlines.js"
import "./packs/submit_upload_csv.js"
import "./packs/download_csv.js"

import Rails from "@rails/ujs"
import { start as startActiveStorage } from "@rails/activestorage"
Rails.start()
startActiveStorage()
